import { Cell, Row, Spacer } from '../../../../components/ReusableComponents/Table'
import { formatPrice } from '../../../../utils/common'
import styles from './PMSBErow.module.scss'

const TripleCell = ({
  primary,
  secondary,
  chargedBookings,
  nonChargedBookings,
  transactionVolume,
  transactionVolumeAvg,
  ...props
}) => {
  return (
    <Cell className={styles.doubleCell} {...props} overflow="visible">
      <div className={styles.doubleCellTerciary}>
        <div>
          <strong>{primary}</strong>
        </div>
        <div className={styles.terciaryLabel}>{secondary}</div>
      </div>
      <div className={styles.doubleCellTerciary}>
        <div>
          <strong>{transactionVolume}</strong>
        </div>
        <div className={styles.terciaryLabel}>{transactionVolumeAvg}</div>
      </div>
      <div className={styles.doubleCellTerciary}>
        <div>
          <strong>{chargedBookings}</strong> / {nonChargedBookings + chargedBookings}
        </div>
      </div>
    </Cell>
  )
}

const TotalRow = ({ months, data }) => (
  <Row className={styles.totalRow}>
    <Spacer />
    <Cell className={styles.totalRowLabels}>
      <div className={styles.totalRowLabel}>
        Invoice total <span>Avr. invoice amount (# hotels)</span>
      </div>
      <div className={styles.totalRowLabel}>
        Transaction volume<span>Avr. volume (# hotels)</span>
      </div>
      <div className={styles.totalRowLabel}>Bookings</div>
    </Cell>
    {months.map(m => (
      <TripleCell
        key={m}
        primary={formatPrice(data?.[m]?.total)}
        secondary={
          <>
            {formatPrice(data?.[m]?.total / data?.[m]?.count)} ({data?.[m]?.count})
          </>
        }
        chargedBookings={data?.[m]?.chargedBookings}
        nonChargedBookings={data?.[m]?.nonChargedBookings}
        transactionVolume={formatPrice(data?.[m]?.transactionVolume)}
        transactionVolumeAvg={
          <>
            {formatPrice(data?.[m]?.transactionVolume / data?.[m]?.count)} (
            {data?.[m]?.count})
          </>
        }
      />
    ))}
  </Row>
)

export default TotalRow
